import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import DisabledCardState from '@components/Cards/DisabledCardState';
import React, { FC } from 'react';
import { useLeaderCardController } from '@components/Leaderboard/useLeaderCardController';
import { useUiState } from '@app/utils/UiStateHook';
import { DateTime } from 'luxon';
import { InfoBubble } from '../InfoBubble';

interface LeaderCardProps {
  groupId: number;
  startDate: string | DateTime;
}

export const LeaderCard2: FC<LeaderCardProps> = ({ groupId, startDate }) => {
  const { leaders, enabled, disabledMessage } = useLeaderCardController(groupId, startDate);
  const uiState = useUiState(enabled);

  return (
    <Card
      variant={'elevation'}
      sx={{
        border: '1px solid',
        borderRadius: 4,
      }}
    >
      <CardContent>
        <div
          className="title-with-info"
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: 6, // space between title and info icon
            flexWrap: 'nowrap',
          }}
        >
          <Typography variant="h5" component="div" sx={{ color: uiState.color }}>
            Top Haters
          </Typography>
          <InfoBubble title="Top Haters">
            The leaderboard is updated each Monday. The number next to each name shows how many weeks that hater was
            successful in meeting their exercise goal thus far.
          </InfoBubble>
        </div>
        {!enabled && (
          <DisabledCardState
            disabledMessage={disabledMessage}
            src="/assets/svg/leaderboard-sloth.svg"
            alt="Get stoked!"
          />
        )}

        {enabled && (
          <div className="card-content-wrapper">
            <img src="/assets/svg/leaderboard-sloth.svg" alt="Top Haters" className="card-logo" />
            <List className="leaderboard-list">
              {Object.keys(leaders).map((rank) => {
                const leader = leaders[Number(rank)];
                if (!leader) return null;
                return (
                  <ListItem key={leader.participant.id}>
                    <ListItemAvatar>
                      <Avatar
                        alt={leader.participant.name}
                        src={leader.participant.avatarUrl}
                        slotProps={{ img: { referrerPolicy: 'no-referrer' } }}
                      />
                    </ListItemAvatar>
                    <ListItemText primary={leader.participant.name} />
                    <Typography variant="cursive" sx={{ marginLeft: '10px', fontSize: '18px' }}>
                      {leader.successfulWeeks}
                    </Typography>
                  </ListItem>
                );
              })}
            </List>
          </div>
        )}
      </CardContent>
      <CardActions></CardActions>
    </Card>
  );
};
